/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 0d57866e19c2c2b488e527c4d91c2228 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BlogGbSCQueryVariables = {
    country: string;
};
export type BlogGbSCQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"BaseLayout_viewer" | "News_viewer">;
    };
};
export type BlogGbSCQuery = {
    readonly response: BlogGbSCQueryResponse;
    readonly variables: BlogGbSCQueryVariables;
};



/*
query BlogGbSCQuery(
  $country: String!
) {
  viewer {
    ...BaseLayout_viewer_1vRKRZ
    ...News_viewer_2h7zyX
  }
}

fragment BaseLayout_viewer_1vRKRZ on Viewer {
  ...SessionLayout_viewer
  ...Header_viewer_1vRKRZ
  ...Footer_viewer_1vRKRZ
}

fragment BlogPostCard_post on BlogPost {
  title
  publicationDate
  slug
  coverImage
}

fragment DesktopHeader_categories on WebsiteMarketingProductCategory {
  name
  products {
    ...DesktopSubmenu_products
  }
}

fragment DesktopSubmenuPlaceholder_product on WebsiteMarketingProduct {
  ...ProductTheme_product
  name
  code
}

fragment DesktopSubmenuProduct_product on WebsiteMarketingProduct {
  name
  code
  shortDescription
}

fragment DesktopSubmenu_products on WebsiteMarketingProduct {
  name
  isComingSoon
  ...DesktopSubmenuProduct_product
  ...DesktopSubmenuPlaceholder_product
}

fragment FooterCountryPicker_viewer on Viewer {
  countries: visibleCountriesByPlatform(platform: WEBSITE) {
    id
    countryAlpha2
    displayName
  }
}

fragment Footer_viewer_1vRKRZ on Viewer {
  ...FooterCountryPicker_viewer
  countryByCode(code: $country) {
    websiteNavigationSections {
      __typename
      ...MenuSections_sections
    }
    id
  }
}

fragment Header_viewer_1vRKRZ on Viewer {
  countryByCode(code: $country) {
    websiteMarketingProductCategories {
      ...DesktopHeader_categories
    }
    websiteNavigationSections {
      __typename
      ...MenuSections_sections
    }
    id
  }
}

fragment MenuSections_sections on WebsiteNavigationSection {
  __typename
  ... on MarketingProductWebsiteNavigationSection {
    productCategory {
      name
      products {
        name
        code
        isComingSoon
      }
    }
  }
  ... on SimpleWebsiteNavigationSection {
    name
    links {
      title
      href
      label
    }
  }
}

fragment News_viewer_2h7zyX on Viewer {
  posts: blogPosts(first: 6) {
    edges {
      cursor
      node {
        ...BlogPostCard_post
        id
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ProductTheme_product on WebsiteMarketingProduct {
  color
}

fragment SessionLayout_viewer on Viewer {
  session {
    id
    token
    expiresAt
  }
  currentUser {
    fullName
    customerNumber
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "country",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isComingSoon",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BlogGbSCQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BaseLayout_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "country",
                "variableName": "country"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "News_viewer",
            "args": [
              {
                "kind": "Literal",
                "name": "count",
                "value": 6
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BlogGbSCQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "session",
            "storageKey": null,
            "args": null,
            "concreteType": "Session",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expiresAt",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customerNumber",
                "args": null,
                "storageKey": null
              },
              (v1/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "countryByCode",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "code",
                "variableName": "country"
              }
            ],
            "concreteType": "Country",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "websiteMarketingProductCategories",
                "storageKey": null,
                "args": null,
                "concreteType": "WebsiteMarketingProductCategory",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "products",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WebsiteMarketingProduct",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "shortDescription",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "color",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "websiteNavigationSections",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "type": "MarketingProductWebsiteNavigationSection",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "productCategory",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WebsiteMarketingProductCategory",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "products",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WebsiteMarketingProduct",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "SimpleWebsiteNavigationSection",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "links",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SimpleWebsiteNavigationLink",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "href",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v1/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "countries",
            "name": "visibleCountriesByPlatform",
            "storageKey": "visibleCountriesByPlatform(platform:\"WEBSITE\")",
            "args": [
              {
                "kind": "Literal",
                "name": "platform",
                "value": "WEBSITE"
              }
            ],
            "concreteType": "Country",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "countryAlpha2",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayName",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "posts",
            "name": "blogPosts",
            "storageKey": "blogPosts(first:6)",
            "args": (v7/*: any*/),
            "concreteType": "BlogPostConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BlogPostEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlogPost",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "publicationDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "coverImage",
                        "args": null,
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "posts",
            "name": "blogPosts",
            "args": (v7/*: any*/),
            "handle": "connection",
            "key": "News_posts",
            "filters": [
              "tags"
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "BlogGbSCQuery",
    "id": null,
    "text": "query BlogGbSCQuery(\n  $country: String!\n) {\n  viewer {\n    ...BaseLayout_viewer_1vRKRZ\n    ...News_viewer_2h7zyX\n  }\n}\n\nfragment BaseLayout_viewer_1vRKRZ on Viewer {\n  ...SessionLayout_viewer\n  ...Header_viewer_1vRKRZ\n  ...Footer_viewer_1vRKRZ\n}\n\nfragment BlogPostCard_post on BlogPost {\n  title\n  publicationDate\n  slug\n  coverImage\n}\n\nfragment DesktopHeader_categories on WebsiteMarketingProductCategory {\n  name\n  products {\n    ...DesktopSubmenu_products\n  }\n}\n\nfragment DesktopSubmenuPlaceholder_product on WebsiteMarketingProduct {\n  ...ProductTheme_product\n  name\n  code\n}\n\nfragment DesktopSubmenuProduct_product on WebsiteMarketingProduct {\n  name\n  code\n  shortDescription\n}\n\nfragment DesktopSubmenu_products on WebsiteMarketingProduct {\n  name\n  isComingSoon\n  ...DesktopSubmenuProduct_product\n  ...DesktopSubmenuPlaceholder_product\n}\n\nfragment FooterCountryPicker_viewer on Viewer {\n  countries: visibleCountriesByPlatform(platform: WEBSITE) {\n    id\n    countryAlpha2\n    displayName\n  }\n}\n\nfragment Footer_viewer_1vRKRZ on Viewer {\n  ...FooterCountryPicker_viewer\n  countryByCode(code: $country) {\n    websiteNavigationSections {\n      __typename\n      ...MenuSections_sections\n    }\n    id\n  }\n}\n\nfragment Header_viewer_1vRKRZ on Viewer {\n  countryByCode(code: $country) {\n    websiteMarketingProductCategories {\n      ...DesktopHeader_categories\n    }\n    websiteNavigationSections {\n      __typename\n      ...MenuSections_sections\n    }\n    id\n  }\n}\n\nfragment MenuSections_sections on WebsiteNavigationSection {\n  __typename\n  ... on MarketingProductWebsiteNavigationSection {\n    productCategory {\n      name\n      products {\n        name\n        code\n        isComingSoon\n      }\n    }\n  }\n  ... on SimpleWebsiteNavigationSection {\n    name\n    links {\n      title\n      href\n      label\n    }\n  }\n}\n\nfragment News_viewer_2h7zyX on Viewer {\n  posts: blogPosts(first: 6) {\n    edges {\n      cursor\n      node {\n        ...BlogPostCard_post\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProductTheme_product on WebsiteMarketingProduct {\n  color\n}\n\nfragment SessionLayout_viewer on Viewer {\n  session {\n    id\n    token\n    expiresAt\n  }\n  currentUser {\n    fullName\n    customerNumber\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'e8000aa17c9284f8bad5c46c879f608d';
export default node;
